import { feedback } from '@ecosystem/newron-design-system'
import * as styles from './index.module.scss'

const LoadingContent = () => {
  const { DotsLoader } = feedback
  return (
    <div className={styles.Wrapper}>
      <div className={styles.Content}>
        <DotsLoader />
        <p>Loading...</p>
      </div>
    </div>
  )
}

export default LoadingContent
